(function () {
    'use strict';

    var network_module = angular.module('honeybook.network', [
        'honeybook.common',
        'honeybook.core',
        'honeybook.network.features',
    ]);

    network_module.controller('NetworkController', Controllers.NetworkController);
    network_module.controller('NetworkConnectionsController', Controllers.NetworkConnectionsController);
    network_module.controller('NetworkEditProfileController', Controllers.NetworkEditProfileController);
    network_module.controller('NetworkProfileController', Controllers.NetworkProfileController);
    network_module.controller('NetworkEditProjectController', Controllers.NetworkEditProjectController);
    network_module.controller('NetworkProjectController', Controllers.NetworkProjectController);
    network_module.controller('NetworkOnboardingIntroductionController', Controllers.NetworkOnboardingIntroductionController);
    network_module.controller('CreateOpportunityController', Controllers.CreateOpportunityController);
    network_module.controller('EditOpportunityController', Controllers.EditOpportunityController);
    network_module.controller('NetworkFeedController', Controllers.NetworkFeedController);
    network_module.controller('NetworkModerationController', Controllers.NetworkModerationController);
    network_module.controller('EmailSettingsController', Controllers.EmailSettingsController);
    network_module.controller('NetworkSettingsController', Controllers.NetworkSettingsController);

    // modals
    network_module.controller('NetworkHelloLinkController', Controllers.NetworkHelloLinkController);
    network_module.controller('NetworkImproveProfileController', Controllers.NetworkImproveProfileController);

    network_module.directive('hbNetworkListItem', Directives.NetworkListItemDirective);
    network_module.directive('hbNetworkProjectCard', Directives.NetworkProjectCardDirective);
    network_module.directive('hbNetworkEditProjectForm', Directives.NetworkEditProjectFormDirective);
    network_module.directive('hbNetworkComments', Directives.NetworkCommentsDirective);
    network_module.directive('hbSocialShare', Directives.SocialShareDirective);

    network_module.service('OpportunityTypesService', Services.OpportunityTypesService);
    network_module.service('GeoLocationHelper', Services.GeoLocationHelpeService);
    
    network_module.config(
        function ($stateProvider, $urlRouterProvider, AppStates, $httpProvider) {

            //////////////////////////
            // State Configurations //
            //////////////////////////

            // Defaults configurations
            // This is handy when you want to define a default state to an abstract state

            // When needed - use regex in the when, otherwise won't work..
            // $urlRouterProvider
            //     .when('/settings', '/settings/company/general');

            // Use $stateProvider to configure your states.
            $stateProvider

                .state(AppStates.root_network, {
                    abstract: true,

                    views: {
                        'main-view': {
                            templateUrl: 'angular/app/modules/network/network_template.html',
                            controller: 'NetworkController',
                            controllerAs: 'networkVm'
                        }
                    }
                })

                .state(AppStates.root_network_navigation, {
                    abstract: true,
                    url: 'community?target',
                    views: {
                        'first-level-navigation': {
                            templateUrl: 'angular/app/modules/core/features/top_nav/top_nav_template.html',
                            controller: 'TopNavController',
                            controllerAs: 'topNavVm'
                        },
                    }
                })

                .state(AppStates.root_network_edit_profile, {

                    url: "/profile/edit",
                    data: {
                        title: 'Edit Public Profile',
                        backToHistoryOrState: AppStates.root_network_opportunities
                    },
                    views: {
                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/profile/network_edit_profile_template.html',
                            controller: 'NetworkEditProfileController',
                            controllerAs: 'networkEditProfileVm'
                        }
                    },
                    resolve: Services.GAPI.resolver
                })

                .state(AppStates.root_network_my_profile, {
                    url: "/profile?tab",

                    data: {
                        title: 'Public Profile',
                        backToHistoryOrState: AppStates.root_network_opportunities,
                        secondLevelNavWithTitle: true
                    },

                    views: {

                        'second-level-navigation@root.network': {
                            templateUrl: 'angular/app/modules/core/features/top_nav/second_level_navigation/title_second_level_navigation_template.html',
                            controller: 'TitleSecondLevelNavigationController',
                            controllerAs: 'secondLevelNavVm'
                        },

                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/profile/network_profile_template.html',
                            controller: 'NetworkProfileController',
                            controllerAs: 'networkProfileVm'
                        }
                    }
                })

                .state(AppStates.root_network_profile, {
                    url: "/profile/:user_id?cid&action&suggestion_source&suggestion_source_details",
                    data: {
                        singlePageNav: true,
                        broadcastPageTitle: true,
                        backToHistoryOrState: AppStates.root_core_navigation_creatives
                    },
                    params: {
                        action: null
                    },
                    views: {
                        'first-level-navigation@root.network': {
                            templateUrl: 'angular/app/modules/core/features/top_nav/single_page/first_level_nav_single_page_template.html',
                            controller: 'FirstLevelNavSinglePageController',
                            controllerAs: 'firstLevelNavSinglePageVm'
                        },

                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/profile/network_profile_template.html',
                            controller: 'NetworkProfileController',
                            controllerAs: 'networkProfileVm'
                        }
                    }
                })

                .state(AppStates.root_network_create_project, {

                    url: "/project/create",
                    views: {
                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/project/network_edit_project_template.html',
                            controller: 'NetworkEditProjectController',
                            controllerAs: 'networkEditProjectVm'
                        }
                    },
                    resolve: Services.GAPI.resolver
                })

                .state(AppStates.root_network_project, {
                    url: "/project/:project_id",
                    params: {
                        share: null
                    },
                    data: {
                        title: 'Public Project',
                        backToHistoryOrState: AppStates.root_network_feed_projects
                    },
                    views: {
                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/project/network_project_template.html',
                            controller: 'NetworkProjectController',
                            controllerAs: 'networkProjectVm'
                        }
                    }
                })

                .state(AppStates.root_network_edit_project, {

                    url: "/project/:project_id/edit",
                    data: {
                        title: 'Edit Project'
                    },
                    params: {
                        focus_id: null
                    },
                    views: {
                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/project/network_edit_project_template.html',
                            controller: 'NetworkEditProjectController',
                            controllerAs: 'networkEditProjectVm'
                        }
                    },
                    resolve: Services.GAPI.resolver
                })

                .state(AppStates.root_network_opportunities, {

                    url: '?opportunity_id&opportunity_ids&vs&oid&disable_replies',
                    data: {
                        title: 'Opportunities',
                        mobileNavPrimary: true,
                        communityPageNav: true
                    },
                    views: {
                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/community/network_community_template.html',
                            controller: 'NetworkFeedController',
                            controllerAs: 'networkFeedVm'
                        }
                    },
                    resolve: Services.GAPI.resolver
                })

                .state(AppStates.root_network_feed_projects, {

                    url: '/projects',
                    data: {
                        title: 'Public Projects',
                        singlePageNav: true,
                        broadcastPageTitle: true,
                        backToHistoryOrState: AppStates.root_network_opportunities
                    },
                    views: {
                        'first-level-navigation@root.network': {
                            templateUrl: 'angular/app/modules/core/features/top_nav/single_page/first_level_nav_single_page_template.html',
                            controller: 'FirstLevelNavSinglePageController',
                            controllerAs: 'firstLevelNavSinglePageVm'
                        },
                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/feed/network_feed_template.html',
                            controller: 'NetworkFeedController',
                            controllerAs: 'networkFeedVm'
                        }
                    },
                    resolve: Services.GAPI.resolver
                })

                .state(AppStates.root_network_myopportunities, {

                    url: '/my-opportunities?opportunity_id&opportunity_ids&vs&oid&disable_replies',
                    data: {
                        title: 'My Opportunity Posts',
                        singlePageNav: true,
                        backToHistoryOrState: AppStates.root_network_opportunities
                    },
                    views: {
                        'first-level-navigation@root.network': {
                            templateUrl: 'angular/app/modules/core/features/top_nav/single_page/first_level_nav_single_page_template.html',
                            controller: 'FirstLevelNavSinglePageController',
                            controllerAs: 'firstLevelNavSinglePageVm'
                        },
                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/feed/network_feed_template.html',
                            controller: 'NetworkFeedController',
                            controllerAs: 'networkFeedVm'
                        }
                    },
                    resolve: Services.GAPI.resolver
                })

                .state(AppStates.root_network_moderation, {
                    url: '/moderation',
                    data: {
                        title: 'Opportunity Moderation',
                        singlePageNav: true,
                        backToHistoryOrState: AppStates.root_network_opportunities
                    },
                    views: {
                        'first-level-navigation@root.network': {
                            templateUrl: 'angular/app/modules/core/features/top_nav/single_page/first_level_nav_single_page_template.html',
                            controller: 'FirstLevelNavSinglePageController',
                            controllerAs: 'firstLevelNavSinglePageVm'
                        },
                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/moderation/network_moderation_template.html',
                            controller: 'NetworkModerationController',
                            controllerAs: 'networkModerationVm'
                        }
                    }
                })

                .state(AppStates.root_network_settings_email, {
                    url: '/email',
                    data: {
                        title: 'HoneyBook Email Preferences',
                        singlePageNav: true,
                        backToState: AppStates.root_network_opportunities
                    },
                    params:{
                        email_unsubscribe_type: null,
                        unsubscribe_email_name: null
                    },
                    views: {
                        'first-level-navigation@root.network': {
                            templateUrl: 'angular/app/modules/core/features/top_nav/single_page/first_level_nav_single_page_template.html',
                            controller: 'FirstLevelNavSinglePageController',
                            controllerAs: 'firstLevelNavSinglePageVm'
                        },

                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/email/email_settings_template.html',
                            controller: 'EmailSettingsController',
                            controllerAs: 'emailSettingsVm'
                        }
                    }
                })

                .state(AppStates.root_network_settings, {
                    url: '/settings',
                    data: {
                        title: 'Opportunity Notification Preferences',
                        singlePageNav: true,
                        backToHistoryOrState: AppStates.root_network_opportunities
                    },
                    views: {
                        'first-level-navigation@root.network': {
                            templateUrl: 'angular/app/modules/core/features/top_nav/single_page/first_level_nav_single_page_template.html',
                            controller: 'FirstLevelNavSinglePageController',
                            controllerAs: 'firstLevelNavSinglePageVm'
                        },

                        'network-view@root.network': {
                            templateUrl: 'angular/app/modules/network/features/settings/network_settings_template.html',
                            controller: 'NetworkSettingsController',
                            controllerAs: 'networkSettingsVm'
                        }
                    }
                });
        }
    );


    // @ngInject
//Verify user logged in when changing states
    core_module.run(function ($rootScope, UsersManager, AppStates, $log, $window, Gon, NetworkOnboardingService, UIUtils) {

        var goToUserDefaultState = function goToUserDefaultState(event, currUser) {
            if (currUser.isClient()) {
                event.preventDefault();
                $rootScope.$state.go(AppStates.root_core_navigation_files);
            }
        };

        $rootScope.$on('$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams) {


                var currUser = UsersManager.getCurrUser();

                if (toState.name.match(/network/i)) {
                    goToUserDefaultState(event, currUser);
                }
            });
    });
})();
